/*@ngInject*/
const UIBrowserDetectionDirective = function ($window, browserUtil) {

    let linkFunction = function ($scope, $elm, $attrs) {

        let userAgent = $window.navigator.userAgent,
            isInternetExplorer10 = $window.navigator.appVersion.indexOf('MSIE 10') !== -1,
            isInternetExplorer11 = browserUtil.isIE11(),
            isChrome = browserUtil.isChrome(),
            isFirefox = browserUtil.isFirefox(),
            isEdge = browserUtil.isEdge(),
            iOS = !!userAgent.match(/iPad/i) || !!userAgent.match(/iPhone/i),
            webkit = !!userAgent.match(/WebKit/i),
            isIosSafari = iOS && webkit && !userAgent.match(/CriOS/i);

        function handleIosSafari() {
            let bodyElm = $('body');

            function handleIosSafariResize() {
                bodyElm.height($window.innerHeight);
            }

            bodyElm.addClass('iosSafari');
            bodyElm.height($window.innerHeight);

            bodyElm.on('resize.handleIosSafariResize', handleIosSafariResize);

            $scope.$on('$destroy', function () {
                bodyElm.off('resize.handleIosSafariResize', handleIosSafariResize);
            });
        }

        if (isInternetExplorer10 || isInternetExplorer11) {
            $($elm).addClass('ie');
        }

        if (isInternetExplorer10) {
            $($elm).addClass('ie10');
        }

        if (isInternetExplorer11) {
            $($elm).addClass('ie11');
        }

        if (isChrome) {
            $($elm).addClass('chrome');
        }

        if (isFirefox) {
            $($elm).addClass('ff');
        }

        if (isEdge) {
            $($elm).addClass('edge');
        }

        if (isIosSafari) {
            handleIosSafari();
        }
    };

    return {
        restrict: 'A',
        link: linkFunction
    };
};

angular.module('umCore')
    .directive('uiBrowserDetection', UIBrowserDetectionDirective);
